import { c as _c } from "react/compiler-runtime";
import type { BjInfoResponse } from '@module/apis/client-side/member/type';
import NotFoundDisplay from '@pc/components/result/NotFoundDisplay';
import dayjs from 'dayjs';
import Link from 'next/link';
interface Props {
  bjInfo: BjInfoResponse;
}
function BannedprofileChannelContent(t0) {
  const $ = _c(16);
  const {
    bjInfo
  } = t0;
  const blockInfo = bjInfo.bjInfo.blockService;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <NotFoundDisplay className="pb-2" content={<p className="mt-5 text-colorFg18">서비스 이용이 정지된 채널 입니다.<br />서비스 이용 정지 기간 중에는 채널을 이용할 수 없습니다.</p>} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <colgroup><col className="w-1/4" /><col className="w-full" /></colgroup>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <td className="border-borderBg11 border-r border-b px-[14px] py-2.5">제재 일시</td>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== blockInfo?.insertDateTime) {
    t4 = dayjs(blockInfo?.insertDateTime).format("YYYY-MM-DD");
    $[3] = blockInfo?.insertDateTime;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <tr>{t3}<td className="border-borderBg11 border-b px-[14px] py-2.5">{t4}</td></tr>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <td className="border-borderBg11 border-r px-[14px] py-2.5">제재 사유</td>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = blockInfo?.message;
  let t8;
  if ($[8] !== t7) {
    t8 = <tr>{t6}<td className="border-borderBg11 px-[14px] py-2.5">{t7}</td></tr>;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t5 || $[11] !== t8) {
    t9 = <table className="mx-auto mt-12 mb-20 w-[720px] border-t-2 border-t-borderBg10 border-b border-b-borderBg11 text-[15px] text-colorFg18">{t2}<tbody className="border-borderBg05 text-left">{t5}{t8}</tbody></table>;
    $[10] = t5;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Link prefetch={false} className="mx-auto mt-2 mb-20 rounded-lg bg-primary px-6 py-[11px] text-[17px] text-white hover:underline" href="/">메인으로 바로가기</Link>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t9) {
    t11 = <section className="flex h-[620px] min-h-max w-full flex-col items-center justify-start pt-14">{t1}{t9}{t10}</section>;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  return t11;
}
export default BannedprofileChannelContent;